package com.partejar.app.feature.relacionamentos.presentation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.partejar.app.core.ui.components.PartejarDockDestination
import com.partejar.app.feature.relacionamentos.data.RelacionamentoFilter
import org.koin.compose.koinInject

@Composable
fun RelacionamentosScreen(
    isDarkTheme: Boolean,
    onThemeToggle: () -> Unit,
    onDestinationSelected: (PartejarDockDestination) -> Unit,
    onOpenDetail: (Long) -> Unit,
    onNew: () -> Unit,
    viewModel: RelacionamentosViewModel = koinInject()
) {
    val state by viewModel.state.collectAsState()
    val filter by viewModel.filter.collectAsState()

    RelacionamentosContent(
        state = state,
        filter = filter,
        isDark = isDarkTheme,
        onThemeToggle = onThemeToggle,
        onFilter = viewModel::select,
        onRetry = viewModel::refresh,
        onLoadNextPage = viewModel::loadNextPage,
        onOpenDetail = onOpenDetail,
        onNew = onNew
    )
}
